export const GEOFENCE_DEFAULT_RADIUS = 100; // geofence radius in meters
export const GEOFENCE_DEFAULT_TIMEDELTA = 7_200_000; // geofence grace period in ms, by default 2 hours

export const VAULT_URL_PATH = 'vault';
